import React, { useEffect, useState } from "react";
import "./claim.scss";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import DataTable from "./Datatable/DataTable";
import DataTableCSV from "./Datatable/DataTableCSV";
import { Modal } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { Api_Url } from "../../../utils/ApiUrl";
import useWeb3 from "../../../hooks/useWeb3";
import AllowClaimHook from "../../../hooks/dataSenders/allowClaim";
import { useWeb3React } from "@web3-react/core";
import { toast } from "react-toastify";
import Loader from "../../../hooks/loader";
import AllowClaimingHook from "../../../hooks/dataSenders/claiming";
import Environment from "../../../utils/Environment";
import {
  getClaimsContract,
  getNFAClaimsContract,
  getAstroNovaClaimsContract,
  getMinersClaimsContract,
  getRainClaimsContract,
  getRainClaimsV2Contract,
} from "../../../utils/contractHelpers";

import CurrentRound from "../../../hooks/dataFetchers/round";
import CuurentRoundRainV2 from "../../../hooks/dataFetchers/roundRainV2";
import CuurentRoundRainV3 from "../../../hooks/dataFetchers/roundRainV3";
import CuurentRoundAstraNovaV2 from "../../../hooks/dataFetchers/roundAstraNovaV2";
import { LEADER_CLAIMS_TOKENS, Claim_Amounts_Config, claimedRebuyConfig, rebuyConfig } from '../../../utils/Constants.js'
import Timer from "../../../hooks/dataFetchers/timer";
import { CSVLink } from "react-csv";
import { logDOM } from "@testing-library/react";
import BigNumber from "bignumber.js";
import { CLAIM_PROJECT_DATA } from '../../../utils/Constants'
import useAdminAllowed from "../../../hooks/userManagement/useAdminAllowed";
import { getContracts } from "../../../utils/getContracts.js";
const Claim = ({
  tomiPrice,
  usdPrice,
  btcPrice,
  pepePrice,
  linkPrice,
  uniPrice,
  dopPrice,
  gemsPrice,
}) => {
  const web3 = useWeb3();
  const { account } = useWeb3React();
  const history = useHistory();
  const [ownerAddress, setOwnerAddress] = useState("");
  const proj = localStorage?.getItem("project");

  const [project, setProject] = useState(() => (CLAIM_PROJECT_DATA[0]?.value)); //(proj ? proj : CLAIM_PROJECT_DATA[0]?.value));
  const [selectedItem, setSelectedItem] = useState({
    imgSrc: CLAIM_PROJECT_DATA[0]?.imageSrc,
    text: CLAIM_PROJECT_DATA[0]?.value,
    // text: proj ? proj : CLAIM_PROJECT_DATA[0]?.value,
  });
  const [checkAdmin, isAdmin] = useAdminAllowed();
  const tok = localStorage.getItem("accessToken");
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [search, setSearch] = useState("");
  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);
  const [show3, setShow3] = useState(false);
  const handleClose3 = () => setShow3(false);
  const { allowClaimingHook } = AllowClaimingHook();
  const { currentRound } = CurrentRound();
  const { cuurentRoundRainV2 } = CuurentRoundRainV2();
  const { cuurentRoundRainV3 } = CuurentRoundRainV3();
  const { cuurentRoundAstraNovaV2 } = CuurentRoundAstraNovaV2();

  const { timer } = Timer();
  const [currentRoundd, setCurrentRoundd] = useState(1);
  const [claimsData, setClaimsData] = useState([]);
  const [allclaimsData, setAllClaimsData] = useState([]);
  const [claimsDataCount, setClaimsDataCount] = useState([]);

  const [claimsCSVData, setClaimsCSVData] = useState([]);
  const [claimsCSVDataHeaders, setClaimsCSVDataHeaders] = useState([]);

  // const [tomiPrice, setTomiPrice] = useState(0);
  const [viewAll, setViewAll] = useState(false);
  const [claimStats, setClaimStats] = useState({
    purchasedAmount: [],
    purchaseAmountETH: 0,
    purchaseAmountUsdt: 0,
    purchaseAmountDOP: 0,
    purchaseAmountWBTC: 0,
    purchaseAmountUSDC: 0,
    purchaseAmountPEPE: 0,
    purchaseAmountLINK: 0,
    purchaseAmountUNI: 0,
    purchaseAmountGEMS: 0,
    purchaseAmountTOMI: 0,

    amountClaimsEth: 0,
    amountClaimsUsdt: 0,
    amountClaimsDopToken: 0,
    amountClaimsWbtc: 0,
    amountClaimsUsdc: 0,
    amountClaimsPepe: 0,
    amountClaimsLink: 0,
    amountClaimsUni: 0,
    amountClaimsTomi: 0,
    amountClaimsGems: 0,
  });
  const [claimedRebuyStats, setClaimedRebuyStats] = useState({
    claimableCount: 0,
    totalClaimed: 0,
    totalClaimedAmount: {
      totalEth: 0,
      totalDopToken: 0,

      totalLink: 0,
      totalPepe: 0,
      totalUni: 0,
      totalUsdc: 0,
      totalUsdt: 0,
      totalWbtc: 0,
      totalTomi: 0,
      totalGems: 0,
    },
    totalRebuyed: 0,
    rebuy: [],
  });

  const [claimStatusFilter, setClaimStatusFilter] = useState("");
  const [statusInf, setStatusInf] = useState();
  const [round, setRound] = useState();
  // const [usdPrice, setUsdPrice] = useState(0);
  const [page, setPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [typeFilter, setTypeFilter] = useState("");
  const [codeBlockFilter, setCodeBlockFilter] = useState(true);
  const [deletedFilter, setDeletedFilter] = useState(false);
  const [uptClaim, setUptClaim] = useState([]);

  const [selected, setSelected] = useState([]);
  const [itemOffset, setItemOffset] = useState(0);
  const [loaderr, setLoarder] = useState(false);
  const [loader, setLoader] = useState(false);

  const [claimStatus, setClaimStatus] = useState();
  const [errorStatus, setErrorStatus] = useState(true);
  const [data, setexceldata] = useState([]);
  const [totalRound, setTotalRound] = useState([]);
  const [settingDisable, setSettingDisable] = useState(true);


  var gasFunPrice;
  web3.eth.getGasPrice().then((result) => {
    var result2 = parseInt(result) + 3000000000;
    gasFunPrice = result2.toString();
  });
  const tokenAddress = Environment.Claim;
  const contract = getClaimsContract(tokenAddress, web3);
  // let Environment = {
  //   ETH: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
  //   USDT: '0x7c2F82424f9681AFe13E8cc552E254B0B90F18c9',
  //   TOMI: '0x3F28F5C870dD87c988711032E2750D0f1408AE6a',
  // }
  const Claiming = async (bool, round, decesion) => {
    let res = await allowClaimingHook(bool, round, decesion, project);
    // console.log("currentRoundd", res, round);
    setClaimStatus(res);
  };
  const openClaim = async (e) => {
    // // // // console.log('checked', e.target.checked)
    let check = e.target.checked;
    setLoarder(true);
    try {
      let res = await allowClaimingHook(false, round, check, project);
      Claiming(true, round, null);
      setLoarder(false);
    } catch (error) {
      // console.log("error", error);
      if (error.message?.includes("AccessControl")) {
        toast.error("AccessControl Denied");
      } else {
        toast.error(error.message);
      }

      setLoarder(false);
    }
  };
  // useEffect(() => {
  //   if (!tomiPrice) {
  //     getTomiPrice();
  //   }
  //   if (!usdPrice) {
  //     axios
  //       .get("https://min-api.cryptocompare.com/data/price?fsym=ETH&tsyms=USD")
  //       .then((res) => {
  //         setUsdPrice(res?.data?.USD);
  //         // setEthUsd(res.data);
  //       });
  //   }
  // }, []);

  useEffect(() => {
    Claiming(true, round, null);
  }, [round]);
  const handlePageChange = (e) => {
    const selectedPage = e.selected;

    setPage(selectedPage);
  };
  const setClaimFun = (leaderIds) => {
    var config = {
      method: "patch",
      url: `${Api_Url}/users/leaders-claims`,

      headers: {
        Authorization: "Bearer " + tok,
      },
      data: {
        leaderIds: leaderIds,
        round: round?.round,
        privateSale: project,
      },
    };

    axios(config)
      .then(function (res) {
        // getAllClaimsData();
        getClaimsData();
        handleClose(false);
        setLoarder(false);
        setShow2(true);
      })
      .catch(function (error) {
        setLoarder(false);
        throw error;
      });
  };

  const getClaimStats1 = () => {
    // setLoarder(true);

    setClaimStats({
      purchasedAmount: [],
      purchaseAmountETH: 0,
      purchaseAmountUsdt: 0,
      purchaseAmountDOP: 0,
      purchaseAmountWBTC: 0,
      purchaseAmountUSDC: 0,
      purchaseAmountPEPE: 0,
      purchaseAmountLINK: 0,
      purchaseAmountUNI: 0,
      purchaseAmountTOMI: 0,
      purchaseAmountGEMS: 0,

      amountClaimsEth: 0,
      amountClaimsUsdt: 0,
      amountClaimsDopToken: 0,
      amountClaimsWbtc: 0,
      amountClaimsUsdc: 0,
      amountClaimsPepe: 0,
      amountClaimsLink: 0,
      amountClaimsUni: 0,
      amountClaimsTomi: 0,
      amountClaimsGems: 0,
    });

    var config = {
      method: "get",
      url: `${Api_Url}/users/leaders-purchased-claims-amount?privateSale=${project}`,
      headers: {
        Authorization: "Bearer " + tok,
      },
    };

    let dynamicQuery = config.url;
    if (round?.round) {
      dynamicQuery += `&round=${round?.round}`;
    }

    config.url = dynamicQuery;
    axios(config)
      .then(function (res) {
        setClaimStats(res?.data?.data);

        // setLoarder(false);
      })
      .catch(function (error) {
        // setLoarder(false);
      });
  };

  const getClaimStats2 = () => {
    // setLoader(true);

    setClaimedRebuyStats({
      claimableCount: 0,
      totalClaimed: 0,
      totalClaimedAmount: {
        totalEth: 0,
        totalDopToken: 0,
        totalTomi: 0,

        totalLink: 0,
        totalPepe: 0,
        totalUni: 0,
        totalUsdc: 0,
        totalUsdt: 0,
        totalWbtc: 0,
        totalGems: 0,
      },
      totalRebuyed: 0,
      rebuy: [],
    });

    var config = {
      method: "get",
      url: `${Api_Url}/users/leaders-claimed-rebuy?privateSale=${project}`,
      headers: {
        Authorization: "Bearer " + tok,
      },
    };

    let dynamicQuery = config.url;
    if (round?.round) {
      dynamicQuery += `&round=${round?.round}`;
    }

    config.url = dynamicQuery;
    axios(config)
      .then(function (res) {
        setClaimedRebuyStats(res?.data?.data);

        // setLoader(false);
      })
      .catch(function (error) {
        // setLoader(false);
      });
  };

  const getClaimsData = () => {
    setLoader(true);
    setClaimsData([]);

    setPageCount(0);
    setSelected([]);
    var config = {
      method: "get",
      url: `${Api_Url}/users/leaders-claims?limit=50&offset=${page + 1
        }&privateSale=${project}`,

      headers: {
        Authorization: "Bearer " + tok,
      },
    };

    let dynamicQuery = config.url;
    if (round?.round) {
      dynamicQuery += `&round=${round?.round}`;
    }
    if (search) {
      dynamicQuery += `&search=${search}`;
    }
    if (statusInf) {
      dynamicQuery += `&status=${statusInf}`;
    }
    if (typeFilter) {
      dynamicQuery += `&leaderType=${typeFilter}`;
    }
    if (!codeBlockFilter) {
      dynamicQuery += `&accessCodeEnabled=${codeBlockFilter}`;
    }
    if (deletedFilter) {
      dynamicQuery += `&isDeleted=${deletedFilter}`;
    }
    if (claimStatusFilter) {
      dynamicQuery += `&claimedStatus=${claimStatusFilter}`;
    }
    config.url = dynamicQuery;
    axios(config)
      .then(function (res) {
        const responsev = res?.data?.data?.leaders;
        const upt = responsev;
        setClaimsData(upt);
        setClaimsDataCount(res?.data?.data?.count);
        setPageCount(res?.data?.data?.pages);
        setLoader(false);
      })
      .catch(function (error) {
        setLoader(false);
      });
  };
  const getAllClaimsData = () => {
    // setLoarder(true);
    setSelected([]);
    setAllClaimsData([]);
    var config = {
      method: "get",
      url: `${Api_Url}/users/leaders-claims?limit=1000&offset=${1}&privateSale=${project}`,

      headers: {
        Authorization: "Bearer " + tok,
      },
    };
    let dynamicQuery = config.url;
    if (round?.round) {
      dynamicQuery += `&round=${round?.round}`;
    }
    if (search) {
      dynamicQuery += `&search=${search}`;
    }
    if (statusInf) {
      dynamicQuery += `&status=${statusInf}`;
    }
    if (typeFilter) {
      dynamicQuery += `&leaderType=${typeFilter}`;
    }
    if (!codeBlockFilter) {
      dynamicQuery += `&accessCodeEnabled=${codeBlockFilter}`;
    }
    if (deletedFilter) {
      dynamicQuery += `&isDeleted=${deletedFilter}`;
    }
    if (claimStatusFilter) {
      dynamicQuery += `&claimedStatus=${claimStatusFilter}`;
    }
    config.url = dynamicQuery;
    axios(config)
      .then(function (res) {
        const leadersData = res?.data?.data?.leaders || [];
        const leadersDataStats = res?.data?.data || [];

        const dataForCsv = leadersData.map((item) => {
          let valueETH = parseFloat(item?.myEarningsEth);
          let truncatedValueETH = Math.floor(valueETH * 100000) / 100000;
          const ethAmount = parseFloat(truncatedValueETH || 0)?.toFixed(5);

          let valueUSDT = parseFloat(item?.myEarningsUsdt);
          let truncatedValueUSDT = Math.floor(valueUSDT * 10000) / 10000;
          const usdAmount = parseFloat(truncatedValueUSDT || 0)?.toFixed(4);

          let valueTOMI = parseFloat(item?.myEarningsTomi);
          let truncatedValueTOMI = Math.floor(valueTOMI * 100000) / 100000;
          const tomiAmount = parseFloat(truncatedValueTOMI || 0)?.toFixed(5);

          let valueWBTC = parseFloat(item?.myEarningsWbtc);
          let truncatedValueWBTC = Math.floor(valueWBTC * 100000) / 100000;
          const wbtcAmount = parseFloat(truncatedValueWBTC || 0)?.toFixed(5);

          let valueUSDC = parseFloat(item?.myEarningsUsdc);
          let truncatedValueUSDC = Math.floor(valueUSDC * 100000) / 100000;
          const usdcAmount = parseFloat(truncatedValueUSDC || 0)?.toFixed(5);

          let check = 0;
          // const round = item?.round;

          const results = [];

          if (ethAmount > check.toFixed(5)) {
            results.push({
              Address: item?.walletAddress,
              Token: "ETH",
              Amount: ethAmount,
              Round: round?.round,
            });
          }

          if (usdAmount > 0) {
            results.push({
              Address: item?.walletAddress,
              Token: "USDT",
              Amount: usdAmount,
              Round: round?.round,
            });
          }

          if (tomiAmount > check.toFixed(5)) {
            results.push({
              Address: item?.walletAddress,
              Token: "TOMI",
              Amount: tomiAmount,
              Round: round?.round,
            });
          }

          if (wbtcAmount > check.toFixed(5)) {
            results.push({
              Address: item?.walletAddress,
              Token: "WBTC",
              Amount: wbtcAmount,
              Round: round?.round,
            });
          }

          if (usdcAmount > 0) {
            results.push({
              Address: item?.walletAddress,
              Token: "USDC",
              Amount: usdcAmount,
              Round: round?.round,
            });
          }

          return results;
        });

        // Add the summary row
        const summaryRow = [
          {
            Round: round?.round,
            Token: "ETH",
            Amount:
              parseFloat(leadersDataStats?.amountClaimsEth)?.toFixed(6) || 0,
          },
          {
            Round: round?.round,
            Token: "USDT",
            Amount:
              parseFloat(leadersDataStats?.amountClaimsUsdt)?.toFixed(4) || 0,
          },

          {
            Round: round?.round,
            Token: "WBTC",
            Amount:
              parseFloat(leadersDataStats?.amountClaimsWbtc)?.toFixed(6) || 0,
          },
          {
            Round: round?.round,
            Token: "USDC",
            Amount:
              parseFloat(leadersDataStats?.amountClaimsUsdc)?.toFixed(4) || 0,
          },
        ];

        const headers = [
          { label: "Address", key: "Address" },
          { label: "Token", key: "Token" },
          { label: "Amount", key: "Amount" },
          { label: "Round", key: "Round" },
        ];

        // Exclude the summary row if all amounts are 0
        if (summaryRow.some((row) => row.Amount > 0)) {
          dataForCsv.push(summaryRow);
        }

        // Flatten the array
        const flattenedDataForCsv = dataForCsv.flat();
        // Headers for CSVLink
        setClaimsCSVData(flattenedDataForCsv);
        setClaimsCSVDataHeaders(headers);

        setAllClaimsData(leadersData);
        setexceldata(leadersData);
        //this data is used to disable claim setting button in case no leader is allowed by admin
        
        const isRoundIncluded = leadersData.some((item) =>
          item?.claimsRound?.includes(parseInt(round?.round, 10))
        );
console.log(leadersData,isRoundIncluded,'isRoundIncluded')
        setSettingDisable(!isRoundIncluded);

        // setLoarder(false);
      })
      .catch(function (error) {
        // setLoarder(false);
      });
  };

  const allowClaim = async () => {
    if (!account) {
      toast.error("Connect Your Wallet");
      return;
    }
    if (claimStatus) {
      toast.info("Turn off claiming first !");
      return;
    }
    if (true) {
      try {
        setErrorStatus(true);
        setLoarder(true);

        let result = [];
        let resultTempTest = [];
        for (let i = 0; i < selected.length; i++) {
          let obj = selected[i];

          // Convert USDT amount

          let usdtAmount = obj.myEarningsUsdt;
          let usdtTruncatedValue = Math.floor(usdtAmount * 10000) / 10000;
          const usdtAmountFormatted = parseFloat(
            usdtTruncatedValue || 0
          )?.toFixed(4);
          const usdtWei = web3.utils.toWei(
            usdtAmountFormatted.toString(),
            "mwei"
          );

          // Convert ETH amount
          let ethAmount = obj.myEarningsEth;
          let ethTruncatedValue = Math.floor(ethAmount * 100000) / 100000;
          const ethAmountFormatted = parseFloat(
            ethTruncatedValue || 0
          )?.toFixed(5);
          const ethWei = web3.utils.toWei(
            ethAmountFormatted.toString(),
            "ether"
          );

          //Convert WBTC amount
          let wbtcAmount = obj.myEarningsWbtc;
          let wbtcTruncatedValue = Math.floor(wbtcAmount * 10000000) / 10000000;
          const wbtcAmountFormatted = parseFloat(
            wbtcTruncatedValue || 0
          )?.toFixed(6);
          const wbtcWei = parseInt(wbtcAmountFormatted * 10 ** 8);
          const wbtcString = wbtcWei.toString();

          // Convert USDC amount
          let usdcAmount = obj.myEarningsUsdc;
          let usdcTruncatedValue = Math.floor(usdcAmount * 100000) / 100000;

          const usdcAmountFormatted = parseFloat(
            usdcTruncatedValue || 0
          )?.toFixed(5);

          const usdcWei = web3.utils.toWei(
            usdcAmountFormatted.toString(),
            "mwei"
          );

          // Convert PEPE amount
          let pepeAmount = obj.myEarningsPepe;
          let pepeTruncatedValue = Math.floor(pepeAmount * 100000) / 100000;
          const pepeAmountFormatted = parseFloat(
            pepeTruncatedValue || 0
          )?.toFixed(5);
          const pepeWei = web3.utils.toWei(
            pepeAmountFormatted.toString(),
            "ether"
          );

          // Convert LINK amount
          let linkAmount = obj.myEarningsLink;
          let linkTruncatedValue = Math.floor(linkAmount * 100000) / 100000;
          const linkAmountFormatted = parseFloat(
            linkTruncatedValue || 0
          )?.toFixed(5);
          const linkWei = web3.utils.toWei(
            linkAmountFormatted.toString(),
            "ether"
          );

          // Convert UNI amount
          let uniAmount = obj.myEarningsUni;
          let uniTruncatedValue = Math.floor(uniAmount * 100000) / 100000;
          const uniAmountFormatted = parseFloat(
            uniTruncatedValue || 0
          )?.toFixed(5);
          const uniWei = web3.utils.toWei(
            uniAmountFormatted.toString(),
            "ether"
          );
          // DOP
          let dopAmount = obj?.myEarningsDopToken;
          let dopTruncatedValue = Math.floor(dopAmount * 100000) / 100000;
          const dopAmountFormatted = parseFloat(
            dopTruncatedValue || 0
          )?.toFixed(5);
          const dopWei = web3.utils.toWei(
            dopAmountFormatted.toString(),
            "ether"
          );

          // TOMI
          let tomiAmount = obj?.myEarningsTomi;
          let tomiTruncatedValue = Math.floor(tomiAmount * 100000) / 100000;
          const tomiAmountFormatted = parseFloat(
            tomiTruncatedValue || 0
          )?.toFixed(5);
          const tomiWei = web3.utils.toWei(
            tomiAmountFormatted.toString(),
            "ether"
          );

          // GEMS
          let gemsAmount = obj?.myEarningsGems;
          let gemsTruncatedValue = Math.floor(gemsAmount * 100000) / 100000;
          const gemsAmountFormatted = parseFloat(
            gemsTruncatedValue || 0
          )?.toFixed(5);
          const gemsWei = web3.utils.toWei(
            gemsAmountFormatted.toString(),
            "ether"
          );

          let data = [
            [Environment.eth, ethWei],
            [Environment.busd, usdtWei],
            [Environment.wbtc, wbtcString],
            [Environment.usdc, usdcWei],
            [Environment.pepe, pepeWei],
            [Environment.link, linkWei],
            [Environment.uni, uniWei],
            [Environment.dop, dopWei],
            [Environment.tomi, tomiWei],
          ];

          let data1 = [];
          if (ethWei !== "0") {
            data1.push([Environment.eth, ethWei]);
          }

          if (usdtWei !== "0") {
            data1.push([Environment.busd, usdtWei]);
          }

          if (wbtcString !== "0") {
            data1.push([Environment.wbtc, wbtcString]);
          }

          if (usdcWei !== "0") {
            data1.push([Environment.usdc, usdcWei]);
          }

          if (pepeWei !== "0") {
            data1.push([Environment.pepe, pepeWei]);
          }
          if (linkWei !== "0") {
            data1.push([Environment.link, linkWei]);
          }
          if (uniWei !== "0") {
            data1.push([Environment.uni, uniWei]);
          }
          if (dopWei !== "0") {
            data1.push([Environment.dop, dopWei]);
          }
          if (tomiWei !== "0") {
            data1.push([Environment.tomi, tomiWei]);
          }
          if (gemsWei !== "0") {
            data1.push([Environment.gems, gemsWei]);
          }

          resultTempTest.push(data1);

          result.push(data);
        }

        let addressesArray = selected.map((item) => item.walletAddress);

        let userIdArray = selected.map((item) => item?._id);

        // let a = await AllowClaimHooked(account, addressesArray, round, ethArray, usdtArray)

        const gas = await contract.methods
          .setClaim(addressesArray, round?.round, resultTempTest)
          .estimateGas({ from: account });
        await contract.methods
          .setClaim(addressesArray, round?.round, resultTempTest)
          .send({
            from: account,
            gas,
            gasPrice: gasFunPrice,
          })
          .on("transactionHash", (trx) => {
            setErrorStatus(false); //code doesn't execute after this contract mehtod calling timeout so apis hit after 7 sec of confirming transaction
            setTimeout(() => {
              setClaimFun(userIdArray);
            }, 7000);
          });

        setLoarder(false);
      } catch (error) {
        // console.log("error: ", error);

        if (errorStatus) {
          toast.error("Selected Claims Failed");
        }

        setLoarder(false);
      }
    }
  };

  function calculateAmount(value, decimals) {
    if (isNaN(value) || value <= 0) return "0";
    return new BigNumber(value)
      .multipliedBy(0.99)
      .multipliedBy(new BigNumber(10).pow(decimals))
      .toFixed(0); // Return a string to avoid precision issues
  }
  const revokeClaim = async () => {
    if (!account) {
      toast.error("Connect Your Wallet");
      return;
    }
    if (claimStatus) {
      toast.info("Turn off claiming first!");
      return;
    }
    // if (true) {
    try {
      setErrorStatus(true);
      setLoarder(true);

      // const tokenAddress = Environment.NFAClaim;
      // const contractNFA = getNFAClaimsContract(tokenAddress, web3);

      let contract, tokenAddress;
      if (project == "RAIN") {
        tokenAddress = Environment.RainClaim;
        contract = getRainClaimsContract(tokenAddress, web3);
      } else if (project == "MINERS") {
        tokenAddress = Environment.MinersClaim;
        contract = getMinersClaimsContract(tokenAddress, web3);
      } else if (project == "ASTRANOVA") {
        tokenAddress = Environment.AstroNovaClaim;

        contract = getAstroNovaClaimsContract(tokenAddress, web3);
      } else if (project == "NFA") {
        tokenAddress = Environment.NFAClaim;
        contract = getNFAClaimsContract(tokenAddress, web3);
      }

      let addressesArray = selected?.map((item) => item.walletAddress);

      let amounts = [];
      for (let i = 0; i < selected?.length; i++) {
        // console.log("iter val: ", selected[i]);

        let ethAmount = calculateAmount(selected[i]?.myEarningsEth, 18);
        let usdtAmount = calculateAmount(selected[i]?.myEarningsUsdt, 6);
        let wbtcAmount = calculateAmount(selected[i]?.myEarningsWbtc, 8);
        let usdcAmount = calculateAmount(selected[i]?.myEarningsUsdc, 6);
        let pepeAmount = calculateAmount(selected[i]?.myEarningsPepe, 18);
        let linkAmount = calculateAmount(selected[i]?.myEarningsLink, 18);
        let uniAmount = calculateAmount(selected[i]?.myEarningsUni, 18);
        let dopAmount = calculateAmount(selected[i]?.myEarningsDopToken, 18);
        let tomiAmount = calculateAmount(selected[i]?.myEarningsTomi, 18);
        let gemsAmount = calculateAmount(selected[i]?.myEarningsGems, 18);

        // let ethAmount = parseInt(
        //   selected[i]?.myEarningsEth * 0.9 * 10 ** 18
        // ).toString();

        // let usdtAmount = parseInt(
        //   selected[i]?.myEarningsUsdt * 0.9 * 10 ** 6
        // ).toString();

        // let wbtcAmount = parseInt(
        //   selected[i]?.myEarningsWbtc * 0.9 * 10 ** 8
        // ).toString();

        // let usdcAmount = parseInt(
        //   selected[i]?.myEarningsUsdc * 0.9 * 10 ** 6
        // ).toString();

        // let pepeAmount = web3.utils.toWei(
        //   (selected[i]?.myEarningsPepe * 0.9).toString(),
        //   "ether"
        // );

        // let linkAmount = web3.utils.toWei(
        //   (selected[i]?.myEarningsLink * 0.9).toString(),
        //   "ether"
        // );

        // let uniAmount = web3.utils.toWei(
        //   (selected[i]?.myEarningsUni * 0.9).toString(),
        //   "ether"
        // );

        // let dopAmount = web3.utils.toWei(
        //   (selected[i]?.myEarningsDopToken * 0.9).toString(),
        //   "ether"
        // );

        // let tomiAmount = web3.utils.toWei(
        //   (selected[i]?.myEarningsTomi * 0.9).toString(),
        //   "ether"
        // );

        // let gemsAmount = web3.utils.toWei(
        //   (selected[i]?.myEarningsGems * 0.9).toString(),
        //   "ether"
        // );
        amounts.push([
          ethAmount,
          usdtAmount,
          wbtcAmount,
          usdcAmount,
          pepeAmount,
          linkAmount,
          uniAmount,
          dopAmount,
          tomiAmount,
          gemsAmount,
        ]);
      }

      // console.log("amounts: ", amounts);

      let leaderIds = selected.map((item) => item?._id);

      let revokeAmount = selected?.map((item) => {
        return {
          leaderId: item?._id,
          revokeEth: item?.myEarningsEth,
          revokeUsdt: item?.myEarningsUsdt,
          revokeUsdc: item?.myEarningsUsdc,
          revokeWbtc: item?.myEarningsWbtc,
          revokeTomi: item?.myEarningsTomi,
          revokeDop: item?.myEarningsDopToken,
          revokeGems: item?.myEarningsGems,
          revokeUni: item?.myEarningsUni,
          revokePepe: item?.myEarningsPepe,
          revokeLink: item?.myEarningsLink,
        };
      });

      // console.log("revoke Amounts : ", revokeAmount);

      setLoarder(true);
      let result1 = [];
      for (let i = 0; i < selected.length; i++) {
        let data = [
          Environment.eth,
          Environment.busd,
          Environment.wbtc,
          Environment.usdc,
          Environment.pepe,
          Environment.link,
          Environment.uni,
          Environment.dop,
          Environment.tomi,
          Environment.gems,
        ];

        result1.push(data);
      }
      // console.log(
      //   addressesArray,
      //   " selected leaders with claims",
      //   "\n",
      //   "amount in wei: ",
      //   amounts,
      //   "\n tokens",
      //   result1
      // );
      const gas = await contract.methods
        .revokeLeaderClaim(addressesArray, result1, amounts, round?.round)
        .estimateGas({ from: account });
      await contract.methods
        .revokeLeaderClaim(addressesArray, result1, amounts, round?.round)
        .send({
          from: account,
          gas,
          gasPrice: gasFunPrice,
        })
        .on("transactionHash", (trx) => {
          setErrorStatus(false); //code doesn't execute after this contract mehtod calling timeout so apis hit after 7 sec of confirming transaction
          setTimeout(() => {
            try {
              setLoarder(true);
              var config = {
                method: "delete",
                url: `${Api_Url}/users/revoke-leaders-claims`,

                headers: {
                  Authorization: "Bearer " + tok,
                },
                data: {
                  round: round?.round,
                  revokeAmount: revokeAmount,
                },
              };
              axios(config)
                .then(function (res) {
                  toast.success("Selected Claims Revoked");
                  // getAllClaimsData();
                  getClaimsData();
                  setSelected([]);
                  setLoarder(false);
                })
                .catch(function (error) {
                  toast.info("Selected Claims Revoked");
                });
              setLoarder(false);
            } catch (error) {
              toast.info("Selected Claims Revoked");
              setLoarder(false);
            }
          }, 10000);
        });

      setLoarder(false);
    } catch (error) {
      if (errorStatus) {
        // toast.error('Selected Claims Failed')
      }

      setLoarder(false);
    }
    // }
  };
  //step wise function to get round
  const firstTimeData = async () => {
    const result = [];

    try {
      let b = await currentRound(project);

      if (b) {
        setRound({ version: 1, round: b });
        roundData(b, 1);

        for (let i = 1; i <= parseInt(b); i++) {
          result.push({ version: 1, round: i });
        }
      }
    } catch (err) {
      console.log(err.message, "Error in currentRound");
    }

    if (project === "RAIN") {
      try {
        let b = await cuurentRoundRainV2(project);

        if (b) {
          setRound({ version: 2, round: b });

          roundData(b, 2);

          for (let i = 1; i <= parseInt(b); i++) {
            result.push({ version: 2, round: i });
          }
        }
      } catch (err) {
        // console.log(err.message, "Error in cuurentRoundRainV2");
      }
      try {
        let b = await cuurentRoundRainV3(project);

        if (b) {
          setRound({ version: 3, round: b });

          roundData(b, 3);

          for (let i = 1; i <= parseInt(b); i++) {
            result.push({ version: 3, round: i });
          }
        }
      } catch (err) {
        // console.log(err.message, "Error in cuurentRoundRainV2");
      }
    } else if (project === "ASTRANOVA") {
      try {
        let b = await cuurentRoundAstraNovaV2(project);

        if (b) {
          setRound({ version: 2, round: b });

          roundData(b, 2);

          for (let i = 1; i <= parseInt(b); i++) {
            if (i > 4) {
              result.push({ version: 2, round: i });
            }
          }
        }
      } catch (err) {
        // console.log(err.message, "Error in cuurentRoundRainV2");
      }
    }

    // console.log("rounds: ", result);
    setTotalRound(result);
  };
  // console.log("projprojectect: ", project);
  const roundData = async (e, version) => {
    // // console.log(e, "eee");
    try {
      if (parseInt(e) <= 1) {
        let c = await timer(e, version);

        if (c) {
          setCurrentRoundd(e);
          // setRound(e)
          // setPrice(c.price/10**18)
          // // // console.log('nooor',c.price);
          // setCurrentTimer(c)
        }
      } else {
        let dummy = [];
        // // console.log(e, "loooop bahis");
        for (let a = 1; a <= e; a++) {
          // // console.log(a, "loooop");
          let c = await timer(a, version);

          dummy.push(c);
        }
        // // console.log(dummy, "loooop");
        calucation(dummy);
      }
    } catch (err) {
      // // console.log(err, "erro in timerTomi");
    }
  };
  const calucation = (e) => {
    let dummy = [];
    let a = "";
    let indexx = "";
    let aaa = e.map((i, index) => {
      let tempLockedLending2 = "";
      if (
        currentTime > parseInt(i.startTime) &&
        currentTime < parseInt(i.endTime)
      ) {
        a = i;
        indexx = index + 1;
        let deff = currentTime - parseInt(i.startTime);
        tempLockedLending2 = { ...i, diffrence: deff, currentround: index + 1 };
        dummy.push(tempLockedLending2);
      } else {
        let deff = currentTime - parseInt(i.startTime);
        tempLockedLending2 = { ...i, diffrence: deff, currentround: index + 1 };
        dummy.push(tempLockedLending2);
      }
    });
    if (a) {
      setCurrentRoundd(indexx);
      // setRound(indexx);
    } else if (dummy?.length > 0) {
      dummy.sort((a, b) => {
        return a?.diffrence - b?.diffrence;
      });

      setCurrentRoundd(dummy[0]?.currentround);
      // setRound(dummy[0]?.currentround);
    }
  };
  var now11 = new Date();
  let createdDate = now11?.getTime();
  // // // console.log(createdDate,'createdDate');
  let currentTime = createdDate / 1000;
  currentTime = parseInt(currentTime);
  //step wise function to get round
  useEffect(() => {
    localStorage.setItem("project", project);

    // roundData();
    firstTimeData();
  }, [project]);

  useEffect(() => {
    if (usdPrice && !viewAll) {
      if (round?.round) {
        getClaimsData();
      }
    }
  }, [
    project,
    round,
    usdPrice,
    search,
    typeFilter,
    page,
    statusInf,
    codeBlockFilter,
    deletedFilter,
    claimStatusFilter,
  ]);
  useEffect(() => {
    if (round?.round) {
      getAllClaimsData();
      getClaimStats1();
      getClaimStats2();
    }
  }, [round, project]);
  // useEffect(() => {
  //   if (viewAll && round) {
  //     getAllClaimsData();
  //   }
  // }, [round, search, typeFilter, statusInf, viewAll, claimStatusFilter]);

  // const getTomiPrice = async () => {
  //   try {
  //     var config = {
  //       method: "get",
  //       url: `${Api_Url}/users/tomi-price`,
  //     };

  //     axios(config)
  //       .then(function (res) {
  //         setTomiPrice(res?.data?.data);
  //       })
  //       .catch(function (error) {
  //         // console.log(error);
  //       });
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //     // throw error;
  //   }
  // };

  const handleItemClick = (imgSrc, text) => {
    setSelectedItem({ imgSrc, text });
    setProject(text);
    // localStorage.setItem("project", text);
  };
  // Helper function to calculate total purchase amount for a token
  const getTokenTotal = (token, multiplier = 1) => {
    if (!claimStats?.purchasedAmount?.length) return 0;
    return claimStats.purchasedAmount
      .filter(item => item?._id?.tokenSelected === token)
      .reduce((sum, item) => sum + (item?.purchaseAmount || 0) * multiplier, 0);
  };

  // Final total price calculation
  const totalPurchasedAmount =
    usdPrice * getTokenTotal("ETH") + getTokenTotal("USDT") + getTokenTotal("USDC") +
    dopPrice * getTokenTotal("DOP") +
    btcPrice * getTokenTotal("WBTC") +
    pepePrice * getTokenTotal("PEPE") +
    linkPrice * getTokenTotal("LINK") +
    uniPrice * getTokenTotal("UNI") +
    tomiPrice * getTokenTotal("TOMI") +
    gemsPrice * getTokenTotal("GEMS");

   const getOwnerAddress = async () => {
    const { contract, contractInstitution } = getContracts(project, web3);
   
    const ownerAddressTemp = await contract.methods
      .owner()
      .call();
    if (ownerAddressTemp) {
      setOwnerAddress(ownerAddressTemp);
    }
  };
   async function claimSetting() {
    if(!account){
      toast.error("Connect Your Wallet");
      return;
    }
    if(account?.toLowerCase() !== ownerAddress?.toLowerCase()){
      toast.error("You are not authorized to access claim settings");
      return;
    }
   setShow3(true)
    }
     useEffect(() => {
   if(project){
    getOwnerAddress();
   }
    
  }, [project]);
  console.log(claimStatus ,'claimStatusclaimStatus')
  return (
    <>
      {loaderr && <Loader />}
      <section className="claim-section">
        <div className="custom-container">
          <div className="upper-heading">
            <div>
              <p className="selfhead">Premium Projects</p>
              <h6>Leader Claims</h6>
            </div>
            <div className="newbtnsets" style={{ alignItems: "center" }}>
              <div className="dropdown">
                <button
                  className="btn btn-secondary dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <div className="projectmain">
                    {selectedItem.imgSrc && (
                      <img
                        src={selectedItem.imgSrc}
                        alt="projectimg"
                        className="projectimg"
                        width={24}
                      />
                    )}
                    <p className="projectpara">{selectedItem.text}</p>
                  </div>
                 <svg xmlns="http://www.w3.org/2000/svg" width="13" height="6" viewBox="0 0 13 6" fill="none">
  <path d="M0 0L2.22397e-07 2.5462L6.2 6L6.2 3.4538L0 0Z" fill="white"/>
  <path d="M12.3984 0L12.3984 2.5462L6.19844 6L6.19844 3.4538L12.3984 0Z" fill="white"/>
</svg>
                </button>
                <ul className="dropdown-menu">
                  {/* <li>
        <a
          className="dropdown-item"
          href="#"
          onClick={() => handleItemClick("", "All Projects")}
        >
          All Projects
        </a>
      </li> */}
                  {CLAIM_PROJECT_DATA?.map((project, index) => (
                    <li key={index}>
                      <a
                        className="dropdown-item"
                        href="#"
                        onClick={() => handleItemClick(project.imageSrc, project.value)}
                      >
                        <div className="projectmain">
                          <img
                            src={project.imageSrc}
                            alt={project.lable}
                            className="projectimg"
                            width={24}
                          />
                          <p className="projectpara">{project.label}</p>
                        </div>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              {/* {project !== "NFA" ? ( */}
              {console.log(settingDisable, 'settingDisable')}
              {isAdmin && <button
                // disabled={
                //   settingDisable &&
                //   project !== "LUCKIFY" &&
                //   project !== "MATCHAIN" &&
                //   project !== "RAIN" &&
                //   project !== "ASTRANOVA" &&
                //   project !== "NFA" &&
                //   project !== "LEIA" &&
                //   project !== "OLYMPUS"
                // }
                onClick={claimSetting}
                data-toggle="tooltip"
                data-placement="top"
                title={settingDisable && "First Allow Some Claims!"}
              >
                Claim Settings{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M9.2502 22L8.8502 18.8C8.63353 18.7167 8.4292 18.6167 8.2372 18.5C8.0452 18.3833 7.85786 18.2583 7.6752 18.125L4.7002 19.375L1.9502 14.625L4.5252 12.675C4.50853 12.5583 4.5002 12.4457 4.5002 12.337V11.663C4.5002 11.5543 4.50853 11.4417 4.5252 11.325L1.9502 9.375L4.7002 4.625L7.6752 5.875C7.85853 5.74167 8.0502 5.61667 8.2502 5.5C8.4502 5.38333 8.6502 5.28333 8.8502 5.2L9.2502 2H14.7502L15.1502 5.2C15.3669 5.28333 15.5712 5.38333 15.7632 5.5C15.9552 5.61667 16.1425 5.74167 16.3252 5.875L19.3002 4.625L22.0502 9.375L19.4752 11.325C19.4919 11.4417 19.5002 11.5543 19.5002 11.663V12.337C19.5002 12.4457 19.4835 12.5583 19.4502 12.675L22.0252 14.625L19.2752 19.375L16.3252 18.125C16.1419 18.2583 15.9502 18.3833 15.7502 18.5C15.5502 18.6167 15.3502 18.7167 15.1502 18.8L14.7502 22H9.2502ZM12.0502 15.5C13.0169 15.5 13.8419 15.1583 14.5252 14.475C15.2085 13.7917 15.5502 12.9667 15.5502 12C15.5502 11.0333 15.2085 10.2083 14.5252 9.525C13.8419 8.84167 13.0169 8.5 12.0502 8.5C11.0669 8.5 10.2375 8.84167 9.5622 9.525C8.88686 10.2083 8.54953 11.0333 8.5502 12C8.5502 12.9667 8.88753 13.7917 9.5622 14.475C10.2369 15.1583 11.0662 15.5 12.0502 15.5ZM12.0502 13.5C11.6335 13.5 11.2792 13.354 10.9872 13.062C10.6952 12.77 10.5495 12.416 10.5502 12C10.5502 11.5833 10.6962 11.229 10.9882 10.937C11.2802 10.645 11.6342 10.4993 12.0502 10.5C12.4669 10.5 12.8212 10.646 13.1132 10.938C13.4052 11.23 13.5509 11.584 13.5502 12C13.5502 12.4167 13.4042 12.771 13.1122 13.063C12.8202 13.355 12.4662 13.5007 12.0502 13.5ZM11.0002 20H12.9752L13.3252 17.35C13.8419 17.2167 14.3212 17.0207 14.7632 16.762C15.2052 16.5033 15.6092 16.191 15.9752 15.825L18.4502 16.85L19.4252 15.15L17.2752 13.525C17.3585 13.2917 17.4169 13.046 17.4502 12.788C17.4835 12.53 17.5002 12.2673 17.5002 12C17.5002 11.7333 17.4835 11.471 17.4502 11.213C17.4169 10.955 17.3585 10.709 17.2752 10.475L19.4252 8.85L18.4502 7.15L15.9752 8.2C15.6085 7.81667 15.2045 7.496 14.7632 7.238C14.3219 6.98 13.8425 6.784 13.3252 6.65L13.0002 4H11.0252L10.6752 6.65C10.1585 6.78333 9.67953 6.97933 9.2382 7.238C8.79686 7.49667 8.39253 7.809 8.0252 8.175L5.5502 7.15L4.5752 8.85L6.72519 10.45C6.64186 10.7 6.58353 10.95 6.5502 11.2C6.51686 11.45 6.5002 11.7167 6.5002 12C6.5002 12.2667 6.51686 12.525 6.5502 12.775C6.58353 13.025 6.64186 13.275 6.72519 13.525L4.5752 15.15L5.5502 16.85L8.0252 15.8C8.39186 16.1833 8.7962 16.5043 9.2382 16.763C9.6802 17.0217 10.1592 17.2173 10.6752 17.35L11.0002 20Z"
                    fill="#fff"
                  />
                </svg>
              </button>}
              {/* ) : null} */}
            </div>
          </div>
          <div className="bottom-tabs">
            <div className="set-twice-between">
              <div className="cshydcycydvc">
                <div
                  class="dropdown vstvcdvtvdvcd"
                  style={{ maxWidth: "150px", width: "100%" }}
                >
                  <button
                    class="btn btn-secondary dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Round {round?.round}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="7"
                      viewBox="0 0 13 7"
                      fill="none"
                    >
                      <path
                        d="M0.163574 0.5L0.163574 3.0462L6.36357 6.5L6.36357 3.9538L0.163574 0.5Z"
                        fill="#FFF"
                      />
                      <path
                        d="M12.562 0.5L12.562 3.0462L6.36201 6.5L6.36201 3.9538L12.562 0.5Z"
                        fill="#FFF"
                      />
                    </svg>
                  </button>
                  <ul class="dropdown-menu">
                    {/* <li>
                  <a class="dropdown-item">All Rounds</a>
                </li> */}
                    {totalRound?.map((elem, index) => {
                      return (
                        <li
                          onClick={() => {
                            setRound(elem);
                            setCurrentRoundd(elem);
                            setPage(0);
                            setTypeFilter("");
                            setStatusInf("");
                          }}
                        >
                          <a class="dropdown-item" href="#">
                            Round {elem?.round}
                          </a>
                        </li>
                      );
                    })}
                  </ul>
                </div>
                <div
                  class="dropdown drop-allclaim formobiled-none"
                  style={{ maxWidth: "150px", width: "100%" }}
                >
                  <button
                    class="dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {!codeBlockFilter
                      ? "Code Blocked"
                      : deletedFilter
                        ? "Soft Deleted"
                        : "All Leaders"}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="7"
                      viewBox="0 0 13 7"
                      fill="none"
                    >
                      <path
                        d="M0.163574 0.5L0.163574 3.0462L6.36357 6.5L6.36357 3.9538L0.163574 0.5Z"
                        fill="#FFF"
                      />
                      <path
                        d="M12.562 0.5L12.562 3.0462L6.36201 6.5L6.36201 3.9538L12.562 0.5Z"
                        fill="#FFF"
                      />
                    </svg>
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a
                        class="dropdown-item"
                        href="#"
                        onClick={() => {
                          setCodeBlockFilter(true);
                          setDeletedFilter(false);
                        }}
                      >
                        All Leaders
                      </a>
                    </li>
                    <li>
                      <a
                        class="dropdown-item"
                        href="#"
                        onClick={() => {
                          setCodeBlockFilter(false);
                          setDeletedFilter(false);
                        }}
                      >
                        Code Blocked
                      </a>
                    </li>
                    <li>
                      <a
                        class="dropdown-item"
                        href="#"
                        onClick={() => {
                          setDeletedFilter(true);
                          setCodeBlockFilter(true);
                        }}
                      >
                        Soft Deleted
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              {isAdmin && <div className="d-flex cshydcycydvc formobiled-none justify-content-end">
                <button
                  disabled={selected?.length < 1}
                  onClick={() => setShow(true)}
                  className={
                    selected?.length < 1
                      ? "allow-claim-btn desktop-btn disable"
                      : "allow-claim-btn desktop-btn"
                  }
                >
                  Allow Selected Claims
                </button>
                <button
                  disabled={selected?.length < 1}
                  onClick={() => revokeClaim()}
                  className={
                    selected?.length < 1
                      ? "revoke-claim-btn desktop-btn disable"
                      : "revoke-claim-btn desktop-btn"
                  }
                >
                  Revoke Selected Claim
                </button>
              </div>}
            </div>

            <div>
              <div className="twice-cards">
                <div className="single-card heighttsett">
                 <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M20.1299 20.8232C17.9918 22.7943 15.1373 24 12 24C8.86866 24 6.01858 22.7994 3.88184 20.835L12 13.5439L20.1299 20.8232ZM10.2871 12L2.3418 19.1211C0.870638 17.1291 0 14.6664 0 12C2.1583e-05 9.33328 0.870316 6.87004 2.3418 4.87793L10.2871 12ZM12 0C15.1365 1.39035e-05 17.991 1.20458 20.1289 3.1748L12.8564 9.68457L14.5977 11.2275L21.6602 4.88184C23.1301 6.87333 24 9.33485 24 12C24 14.6653 23.1293 17.1266 21.6592 19.1182L3.88184 3.16309C6.01846 1.19925 8.86919 0 12 0Z" fill="white"/>
</svg>
                  <p className="up-text">Purchased Amount</p>
 {/* {console.log('usdPrice',usdPrice ,tomiPrice,  )} */}
                  {!usdPrice || loaderr ? (
                    <h6>Loading...</h6>
                  ) : (
                    <>
                        <h6>
                          ~${parseFloat(totalPurchasedAmount?.toFixed(4)).toLocaleString()}
                        </h6>

                      <div className="twice-text lowestttext">
                        {LEADER_CLAIMS_TOKENS?.map(({ symbol, decimals }) => {
                          const tokens = claimStats?.purchasedAmount || [];
                          const token = tokens.find(
                            (t) => t?._id?.tokenSelected === symbol
                          );
                          const amount = parseFloat(token?.purchaseAmount || 0);

                          return amount > 0 ? (
                            <p key={symbol}>
                              {amount.toFixed(decimals).toLocaleString()} {symbol}
                            </p>
                          ) : null;
                        })}
                      
                      </div>
                    </>
                  )}
                  
                </div>
                <div className="single-card heighttsett">
                 <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M18.6895 15.4594L6.58086 15.4593L6.58086 13.5855L18.6895 13.5855L18.6895 15.4594Z" fill="white"/>
  <path d="M20.2041 9.11768L8.0955 9.11767L8.81626 7.2438L20.2041 7.2438L20.2041 9.11768Z" fill="white"/>
  <path d="M6.07715 5.8739L3.12206 5.8739L3.12206 4.00002L6.07715 4.00002L6.07715 5.8739Z" fill="white"/>
  <path d="M16.9153 14.972L18.7254 7.24332L20.2036 7.24332L20.2036 9.11719L18.7254 15.4569L16.9153 14.972Z" fill="white"/>
  <path d="M8.37933 15.0078L7.00989 8.50446L5.19979 8.98945L6.56923 15.4928L8.37933 15.0078Z" fill="white"/>
  <path d="M8.37834 15.0085L6.04784 4.02005L4.23774 4.50505L6.56824 15.4935L8.37834 15.0085Z" fill="white"/>
  <mask id="path-7-inside-1_1173_55304" fill="white">
    <ellipse cx="9.82491" cy="18.3784" rx="1.58565" ry="1.62163"/>
  </mask>
  <path d="M11.4106 18.3784H9.78362C9.78362 18.3826 9.78322 18.385 9.78302 18.386C9.78281 18.3871 9.78261 18.3876 9.78252 18.3878C9.78222 18.3885 9.78203 18.3885 9.78288 18.3876C9.78375 18.3867 9.78763 18.3831 9.79621 18.3794C9.80057 18.3775 9.80567 18.3758 9.81122 18.3746C9.81687 18.3734 9.82166 18.3731 9.82491 18.3731V20V21.627C11.6334 21.627 13.0375 20.1379 13.0375 18.3784H11.4106ZM9.82491 20V18.3731C9.82816 18.3731 9.83295 18.3734 9.8386 18.3746C9.84415 18.3758 9.84925 18.3775 9.85362 18.3794C9.8622 18.3831 9.86607 18.3867 9.86694 18.3876C9.8678 18.3885 9.8676 18.3885 9.86731 18.3878C9.86722 18.3876 9.86701 18.3871 9.8668 18.386C9.86661 18.385 9.86621 18.3826 9.86621 18.3784H8.23926H6.61231C6.61231 20.1379 8.01643 21.627 9.82491 21.627V20ZM8.23926 18.3784H9.86621C9.86621 18.3742 9.86661 18.3718 9.8668 18.3708C9.86701 18.3697 9.86722 18.3692 9.86731 18.369C9.8676 18.3683 9.8678 18.3683 9.86694 18.3692C9.86607 18.3701 9.8622 18.3737 9.85362 18.3774C9.84925 18.3793 9.84415 18.381 9.8386 18.3822C9.83295 18.3834 9.82816 18.3837 9.82491 18.3837V16.7568V15.1298C8.01643 15.1298 6.61231 16.6189 6.61231 18.3784H8.23926ZM9.82491 16.7568V18.3837C9.82166 18.3837 9.81687 18.3834 9.81122 18.3822C9.80567 18.381 9.80057 18.3793 9.79621 18.3774C9.78763 18.3737 9.78375 18.3701 9.78288 18.3692C9.78203 18.3683 9.78222 18.3683 9.78252 18.369C9.78261 18.3692 9.78281 18.3697 9.78302 18.3708C9.78322 18.3718 9.78362 18.3742 9.78362 18.3784H11.4106H13.0375C13.0375 16.6189 11.6334 15.1298 9.82491 15.1298V16.7568Z" fill="white" mask="url(#path-7-inside-1_1173_55304)"/>
  <mask id="path-9-inside-2_1173_55304" fill="white">
    <ellipse cx="15.446" cy="18.3779" rx="1.58565" ry="1.62163"/>
  </mask>
  <path d="M17.0317 18.3779H15.4047C15.4047 18.3821 15.4043 18.3845 15.4041 18.3855C15.4039 18.3865 15.4037 18.387 15.4036 18.3873C15.4033 18.388 15.4031 18.3879 15.404 18.3871C15.4048 18.3862 15.4087 18.3825 15.4173 18.3788C15.4217 18.3769 15.4268 18.3752 15.4323 18.3741C15.438 18.3729 15.4428 18.3725 15.446 18.3725V19.9995V21.6264C17.2545 21.6264 18.6586 20.1374 18.6586 18.3779H17.0317ZM15.446 19.9995V18.3725C15.4493 18.3725 15.454 18.3729 15.4597 18.3741C15.4652 18.3752 15.4703 18.3769 15.4747 18.3788C15.4833 18.3825 15.4872 18.3862 15.488 18.3871C15.4889 18.3879 15.4887 18.388 15.4884 18.3873C15.4883 18.387 15.4881 18.3865 15.4879 18.3855C15.4877 18.3845 15.4873 18.3821 15.4873 18.3779H13.8604H12.2334C12.2334 20.1374 13.6375 21.6264 15.446 21.6264V19.9995ZM13.8604 18.3779H15.4873C15.4873 18.3736 15.4877 18.3712 15.4879 18.3702C15.4881 18.3692 15.4883 18.3687 15.4884 18.3684C15.4887 18.3677 15.4889 18.3678 15.488 18.3686C15.4872 18.3695 15.4833 18.3732 15.4747 18.3769C15.4703 18.3788 15.4652 18.3805 15.4597 18.3816C15.454 18.3828 15.4493 18.3832 15.446 18.3832V16.7562V15.1293C13.6375 15.1293 12.2334 16.6183 12.2334 18.3779H13.8604ZM15.446 16.7562V18.3832C15.4428 18.3832 15.438 18.3828 15.4323 18.3816C15.4268 18.3805 15.4217 18.3788 15.4173 18.3769C15.4087 18.3732 15.4048 18.3695 15.404 18.3686C15.4031 18.3678 15.4033 18.3677 15.4036 18.3684C15.4037 18.3687 15.4039 18.3692 15.4041 18.3702C15.4043 18.3712 15.4047 18.3736 15.4047 18.3779H17.0317H18.6586C18.6586 16.6183 17.2545 15.1293 15.446 15.1293V16.7562Z" fill="white" mask="url(#path-9-inside-2_1173_55304)"/>
</svg>
                  <p className="up-text">Amount in Claims</p>
                  {loaderr ? (
                    <h6>Loading...</h6>
                  ) : (
                    <>
                      <h6>
                        ~$
                        {parseFloat(
                          (
                            (claimStats?.amountClaimsEth || 0) * usdPrice +
                            (claimStats?.amountClaimsUsdt || 0) +
                            (claimStats?.amountClaimsTomi || 0) * tomiPrice +
                            (claimStats?.amountClaimsWbtc || 0) * btcPrice +
                            (claimStats?.amountClaimsUsdc || 0) +
                            (claimStats?.amountClaimsPepe || 0) * pepePrice +
                            (claimStats?.amountClaimsLink || 0) * linkPrice +
                            (claimStats?.amountClaimsUni || 0) * uniPrice +
                            (claimStats?.amountClaimsDopToken || 0) * dopPrice +
                            (claimStats?.amountClaimsGems || 0) * gemsPrice
                          )?.toFixed(2)
                        ).toLocaleString() || 0}{" "}
                      </h6>

                      <div className="twice-text lowestttext">
                        {Claim_Amounts_Config?.map(({ symbol, key, decimals }) => {
                          const rawAmount = claimStats?.[key];
                          const amount = parseFloat(rawAmount || 0).toFixed(decimals);
                          return amount > 0 ? (
                            <p key={symbol}>
                              <span></span>
                              {amount} {symbol}
                            </p>
                          ) : null;
                        })}
                      
                      </div>
                    </>
                  )}
                </div>
                <div className="single-card heighttsett">
                 <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M18.1738 4.37109L5.7599 4.3711L5.7599 6.17423L18.1738 6.17423L18.1738 4.37109Z" fill="white"/>
  <path d="M9.08887 11.9995L5.13583 11.9995L5.13583 13.8027L9.08887 13.8027L9.08887 11.9995Z" fill="white"/>
  <path d="M18.9375 11.9995L14.9845 11.9995L14.9845 13.8027L18.9375 13.8027L18.9375 11.9995Z" fill="white"/>
  <path d="M18.9375 13.8032L18.9375 4.37141L17.1344 4.37141L17.1344 13.8032L18.9375 13.8032Z" fill="white"/>
  <path d="M6.87012 13.8032L6.87012 4.37141L5.06698 4.37141L5.06698 13.8032L6.87012 13.8032Z" fill="white"/>
  <path d="M7.21387 15.0129L7.21387 16.9862L11.9954 19.6629L11.9954 17.6896L7.21387 15.0129Z" fill="white"/>
  <path d="M16.7871 15.013L16.7871 16.9863L12.0055 19.663L11.1789 18.4193L12.0055 17.6897L16.7871 15.013Z" fill="white"/>
  <path d="M12.9014 15.4538L12.9014 9.43384L11.0982 10.4394L11.0982 16.3723L12.9014 15.4538Z" fill="white"/>
</svg>
                  <p className="up-text">Claimed</p>
                  {claimsDataCount ? (
                    <h6>
                      {claimedRebuyStats?.totalClaimed}/{claimsDataCount}
                    </h6>
                  ) : (
                    <h6>0/0</h6>
                  )}

                  <div className="twice-text lowestttext">
                    {claimedRebuyConfig.map(({ symbol, key, decimals }) => {
                      const amount = parseFloat(claimedRebuyStats?.totalClaimedAmount?.[key] || 0).toFixed(decimals);
                      return amount > 0 ? (
                        <p key={symbol}>
                          <span></span>
                          {amount} {symbol}
                        </p>
                      ) : null;
                    })}
                    
                  </div>
                </div>
                {/* {project === 'MATCHAIN' ? null : } */}
                <div className="single-card heighttsett">
               <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M20.1299 20.8232C17.9918 22.7943 15.1373 24 12 24C8.86866 24 6.01858 22.7994 3.88184 20.835L12 13.5439L20.1299 20.8232ZM10.2871 12L2.3418 19.1211C0.870638 17.1291 0 14.6664 0 12C2.1583e-05 9.33328 0.870316 6.87004 2.3418 4.87793L10.2871 12ZM12 0C15.1365 1.39035e-05 17.991 1.20458 20.1289 3.1748L12.8564 9.68457L14.5977 11.2275L21.6602 4.88184C23.1301 6.87333 24 9.33485 24 12C24 14.6653 23.1293 17.1266 21.6592 19.1182L3.88184 3.16309C6.01846 1.19925 8.86919 0 12 0Z" fill="white"/>
</svg>

                  <p className="up-text">Re-buy {project}</p>
                  {claimedRebuyStats?.rebuy &&
                    claimedRebuyStats?.rebuy?.length > 0 ? (
                    <h6>
                      ~$
                      {parseFloat(
                        claimedRebuyStats?.rebuy[0]?.totalEth * usdPrice +
                        claimedRebuyStats?.rebuy[0]?.totalDopToken *
                        dopPrice +
                        claimedRebuyStats?.rebuy[0]?.totalUsdc +
                        claimedRebuyStats?.rebuy[0]?.totalUsdt +
                        claimedRebuyStats?.rebuy[0]?.totalWbtc * btcPrice +
                        claimedRebuyStats?.rebuy[0]?.totalPepe * pepePrice +
                        claimedRebuyStats?.rebuy[0]?.totalLink * linkPrice +
                        claimedRebuyStats?.rebuy[0]?.totalUni * uniPrice +
                        claimedRebuyStats?.rebuy[0]?.totalTomi * tomiPrice +
                        claimedRebuyStats?.rebuy[0]?.totalGems * gemsPrice
                      )?.toFixed(2)}
                    </h6>
                  ) : (
                    <h6>$0 </h6>
                  )}

                  <div className="twice-text lowestttext">
                    {rebuyConfig.map(({ symbol, key, decimals }) => {
                      const hasData = claimedRebuyStats?.rebuy?.length > 0;
                      const amount = hasData
                        ? parseFloat(claimedRebuyStats?.rebuy[0]?.[key] || 0).toFixed(decimals)
                        : "0";

                      return amount > 0 ? (
                        <p key={symbol}>
                          <span></span>
                          {amount} {symbol}
                        </p>
                      ) : null;
                    })}
                  
                  </div>
                </div>
              </div>
              <div className="inner-div">
                <div className="custom-option-field">
                  <input
                    type="search"
                    onChange={(e) => {
                      if (page != 0) {
                        setPage(0);
                      }
                      setTimeout(() => {
                        setSearch(e.target.value);
                      }, 2000);
                    }}
                    placeholder="Search..."
                  />
              
                  <svg className="img-fluid search-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
  <path d="M10.0003 8.73281C9.37507 9.70902 8.28091 10.356 7.03563 10.356C5.09272 10.356 3.51769 8.78102 3.51769 6.83812C3.51769 4.89522 5.09272 3.32018 7.03563 3.32018C8.97853 3.32018 10.5536 4.89522 10.5536 6.83812C10.5536 7.39671 10.4234 7.9249 10.1917 8.39399L12.5731 8.39399C12.7119 7.89913 12.7861 7.37729 12.7861 6.83812C12.7861 3.66222 10.2115 1.08765 7.03563 1.08765C3.85973 1.08765 1.28516 3.66222 1.28516 6.83812C1.28516 10.014 3.85973 12.5886 7.03563 12.5886C8.66086 12.5886 10.1286 11.9144 11.1745 10.8304L10.0003 8.73281Z" fill="#85A8AE"/>
  <path d="M14.9071 16.835L15.6355 14.1168L10.0369 8.66481L9.30852 11.383L14.9071 16.835Z" fill="#85A8AE"/>
</svg>
                </div>
                {/* <div class="dropdown">
                  <button
                    onClick={() => setTypeFilter("")}
                    class="dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Type
                    <img
                      src="\assets\arrow-down.svg"
                      alt="img"
                      className="img-fluid"
                    />
                  </button>
                  <ul class="dropdown-menu">
                    <li onClick={() => setTypeFilter("")}>
                      <a class="dropdown-item" href="#">
                        All Leaders
                      </a>
                    </li>
                    <li onClick={() => setTypeFilter("god_agent")}>
                      <a class="dropdown-item" href="#">
                        God Leader
                      </a>
                    </li>
                    <li onClick={() => setTypeFilter("mega_agent")}>
                      <a class="dropdown-item" href="#">
                        Mega Leader
                      </a>
                    </li>
                    <li onClick={() => setTypeFilter("super_agent")}>
                      <a class="dropdown-item" href="#">
                        Super Leader
                      </a>
                    </li>
                    <li onClick={() => setTypeFilter("agent")}>
                      <a class="dropdown-item" href="#">
                        Leader
                      </a>
                    </li>
                    <li onClick={() => setTypeFilter("mini_agent")}>
                      <a class="dropdown-item" href="#">
                        Ambassador
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="dropdown">
                  <button
                    class="dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Status
                    <img
                      src="\assets\arrow-down.svg"
                      alt="img"
                      className="img-fluid"
                    />
                  </button>
                  <ul class="dropdown-menu">
                    <li
                      onClick={() => {
                        setStatusInf("");
                      }}
                    >
                      <a class="dropdown-item" href="#">
                        All
                      </a>
                    </li>
                    <li
                      onClick={() => {
                        setStatusInf("allowed");
                      }}
                    >
                      <a class="dropdown-item" href="#">
                        Allowed
                      </a>
                    </li>
                    <li
                      onClick={() => {
                        setStatusInf("pending");
                      }}
                    >
                      <a class="dropdown-item" href="#">
                        Pending
                      </a>
                    </li>
                  </ul>
                </div> */}
                {/* <div class="dropdown">
                  <button
                    class="dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Allow Status
                    <img
                      src="\assets\arrow-down.svg"
                      alt="img"
                      className="img-fluid"
                    />
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a class="dropdown-item" href="#">
                        Allowed
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item" href="#">
                        Pending
                      </a>
                    </li>
                  </ul>
                </div> */}

                <div class="dropdown set-custom-type-dropdown-mobile">
                  <button
                    // onClick={() => setTypeFilter("")}
                    class="dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {typeFilter == "god_agent"
                      ? "God Leader"
                      : typeFilter == "mega_agent"
                        ? "Mega Leader"
                        : typeFilter == "super_agent"
                          ? "Super Leader"
                          : typeFilter == "agent"
                            ? "Leader"
                            : "Type"}
                 <svg xmlns="http://www.w3.org/2000/svg" width="13" height="6" viewBox="0 0 13 6" fill="none">
  <path d="M0 0L2.22397e-07 2.5462L6.2 6L6.2 3.4538L0 0Z" fill="white"/>
  <path d="M12.3984 0L12.3984 2.5462L6.19844 6L6.19844 3.4538L12.3984 0Z" fill="white"/>
</svg>
                  </button>
                  <ul class="dropdown-menu">
                    <li onClick={() => setTypeFilter("")}>
                      <a class="dropdown-item" href="#">
                        All Leaders
                      </a>
                    </li>
                    <li onClick={() => setTypeFilter("god_agent")}>
                      <a class="dropdown-item" href="#">
                        God Leader
                      </a>
                    </li>
                    <li onClick={() => setTypeFilter("mega_agent")}>
                      <a class="dropdown-item" href="#">
                        Mega Leader
                      </a>
                    </li>
                    <li onClick={() => setTypeFilter("super_agent")}>
                      <a class="dropdown-item" href="#">
                        Super Leader
                      </a>
                    </li>
                    <li onClick={() => setTypeFilter("agent")}>
                      <a class="dropdown-item" href="#">
                        Leader
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="dropdown">
                  <button
                    class="dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {claimStatusFilter == "claimed"
                      ? "Claimed"
                      : claimStatusFilter == "unclaimed"
                        ? "Unclaimed"
                        : "Claim Status"}
                   <svg xmlns="http://www.w3.org/2000/svg" width="13" height="6" viewBox="0 0 13 6" fill="none">
  <path d="M0 0L2.22397e-07 2.5462L6.2 6L6.2 3.4538L0 0Z" fill="white"/>
  <path d="M12.3984 0L12.3984 2.5462L6.19844 6L6.19844 3.4538L12.3984 0Z" fill="white"/>
</svg>
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a
                        class="dropdown-item"
                        href="#"
                        onClick={() => {
                          setClaimStatusFilter("");
                        }}
                      >
                        All
                      </a>
                    </li>
                    <li>
                      <a
                        class="dropdown-item"
                        href="#"
                        onClick={() => {
                          setClaimStatusFilter("claimed");
                        }}
                      >
                        Claimed
                      </a>
                    </li>
                    <li>
                      <a
                        class="dropdown-item"
                        href="#"
                        onClick={() => {
                          setClaimStatusFilter("unclaimed");
                        }}
                      >
                        Unclaimed
                      </a>
                    </li>
                  </ul>
                </div>

                <div class="dropdown">
                  <button
                    class="dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {statusInf == "allowed"
                      ? "Allowed"
                      : statusInf == "pending"
                        ? "Pending"
                        : "Allow Status"}
                   <svg xmlns="http://www.w3.org/2000/svg" width="13" height="6" viewBox="0 0 13 6" fill="none">
  <path d="M0 0L2.22397e-07 2.5462L6.2 6L6.2 3.4538L0 0Z" fill="white"/>
  <path d="M12.3984 0L12.3984 2.5462L6.19844 6L6.19844 3.4538L12.3984 0Z" fill="white"/>
</svg>
                  </button>
                  <ul class="dropdown-menu">
                    <li
                      onClick={() => {
                        setStatusInf("");
                      }}
                    >
                      <a class="dropdown-item" href="#">
                        All
                      </a>
                    </li>
                    <li
                      onClick={() => {
                        setStatusInf("allowed");
                      }}
                    >
                      <a class="dropdown-item" href="#">
                        Allowed
                      </a>
                    </li>
                    <li
                      onClick={() => {
                        setStatusInf("pending");
                      }}
                    >
                      <a class="dropdown-item" href="#">
                        Pending
                      </a>
                    </li>
                  </ul>
                </div>

                <CSVLink
                  className="download-table-xls-button  nnn desktop-btn"
                  data={claimsCSVData}
                  headers={claimsCSVDataHeaders}
                  filename={"ClaimsData.csv"}
                >
                  Download CSV
                </CSVLink>
              </div>
              <div class="dropdown sjcbvysvs mobile-btn d-none">
                <button
                  class="dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <div>
                    {!codeBlockFilter
                      ? "Code Blocked"
                      : deletedFilter
                        ? "Soft Deleted"
                        : "All Leaders"}
                    <img
                      src="\assets\arrow-down.svg"
                      alt="img"
                      className="img-fluid ms-2"
                    />
                  </div>
                </button>
                <ul class="dropdown-menu">
                  <li>
                    <a
                      class="dropdown-item"
                      href="#"
                      onClick={() => {
                        setCodeBlockFilter(true);
                        setDeletedFilter(false);
                      }}
                    >
                      All Leaders
                    </a>
                  </li>
                  <li>
                    <a
                      class="dropdown-item"
                      href="#"
                      onClick={() => {
                        setCodeBlockFilter(false);
                        setDeletedFilter(false);
                      }}
                    >
                      Code Blocked
                    </a>
                  </li>
                  <li>
                    <a
                      class="dropdown-item"
                      href="#"
                      onClick={() => {
                        setDeletedFilter(true);
                        setCodeBlockFilter(true);
                      }}
                    >
                      Soft Deleted
                    </a>
                  </li>
                </ul>
              </div>
              <div class="dropdown sjcbvysvs mobile-btn d-none">
                <button
                  class="dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <div>
                    {!codeBlockFilter
                      ? "Code Blocked"
                      : deletedFilter
                        ? "Soft Deleted"
                        : "All Leaders"}
                    <img
                      src="\assets\arrow-down.svg"
                      alt="img"
                      className="img-fluid ms-2"
                    />
                  </div>
                </button>
                <ul class="dropdown-menu">
                  <li>
                    <a
                      class="dropdown-item"
                      href="#"
                      onClick={() => {
                        setCodeBlockFilter(true);
                        setDeletedFilter(false);
                      }}
                    >
                      All Leaders
                    </a>
                  </li>
                  <li>
                    <a
                      class="dropdown-item"
                      href="#"
                      onClick={() => {
                        setCodeBlockFilter(false);
                        setDeletedFilter(false);
                      }}
                    >
                      Code Blocked
                    </a>
                  </li>
                  <li>
                    <a
                      class="dropdown-item"
                      href="#"
                      onClick={() => {
                        setDeletedFilter(true);
                        setCodeBlockFilter(true);
                      }}
                    >
                      Soft Deleted
                    </a>
                  </li>
                </ul>
              </div>
              <CSVLink
                className="download-table-xls-button  nnn mobile-btn d-none"
                data={claimsCSVData}
                headers={claimsCSVDataHeaders}
                filename={"ClaimsData.csv"}
              >
                Download CSV
              </CSVLink>
              {/* <ReactHTMLTableToExcel
                id="test-table-xls-button"
                className="download-table-xls-button  nnn mobile-btn d-none"
                table="table-to-xls"
                filename="tablexls"
                sheet="tablexls"
                buttonText="Download as CSV"
              /> */}
              <button
                disabled={selected?.length < 1}
                onClick={() => setSelected(true)}
                className={
                  selected?.length < 1
                    ? "allow-claim-btn mobile-btn d-none disable"
                    : "allow-claim-btn mobile-btn d-none"
                }
              >
                Allow All Claims
              </button>
              <button
                disabled={selected?.length < 1}
                onClick={() => setShow(true)}
                className={
                  selected?.length < 1
                    ? "allow-claim-btn mobile-btn d-none disable"
                    : "allow-claim-btn mobile-btn d-none"
                }
              >
                Allow Selected Claims
              </button>
              <button
                disabled={selected?.length < 1}
                onClick={() => revokeClaim()}
                className={
                  selected?.length < 1
                    ? "revoke-claim-btn mobile-btn d-none disable"
                    : "revoke-claim-btn mobile-btn d-none"
                }
              >
                Revoke Selected Claim
              </button>
              {/* {console.log(viewAll , allclaimsData , claimsData, 'viewAll ? allclaimsData : claimsData')} */}
              <DataTable
                setClaimsData={setClaimsData}
                claimsData={viewAll ? allclaimsData : claimsData}
                usdPrice={usdPrice}
                setSelected={setSelected}
                selected={selected}
                claimStats={claimStats}
                round={round}
                uptclaimset={uptClaim}
                checkBoxVal={Math.random()}
                tomiPrice={tomiPrice}
                loader={loader}
                btcPrice={btcPrice}
                pepePrice={pepePrice}
                linkPrice={linkPrice}
                uniPrice={uniPrice}
                dopPrice={dopPrice}
                gemsPrice={gemsPrice}
                project={project}
                claimStatus={claimStatus}
              />
            </div>
            {/******************  this DataTable is only for csv and it is display none ***************************/}
            {/* <DataTableCSV
              claimsData={allclaimsData}
              claimStats={claimStats}
              round={round}
              xlId={"table-to-xls"}
            /> */}
            {/******************  this DataTable is only for csv and it is display none ***************************/}
          </div>
          <div className="footer-content mt-2 viewAll">
            <div className="left-f ">
              {viewAll ? (
                <h6 onClick={() => setViewAll(false)}>
                  View Paginated Entries
                </h6>
              ) : (
                <h6 onClick={() => setViewAll(true)}>Show All</h6>
              )}
              {/* <h6>SHOWING 1-10 OF 145</h6> */}
              {/* <h6>SHOWING 1-10 OF 145</h6> */}
            </div>
            {viewAll || (
              <div className="right-f">
                <nav aria-label="Page navigation example">
                  <ul class="pagination">
                    <nav aria-label="Page navigation example">
                      {pageCount > 0 ? (
                        <ul class="text-center">
                          <ReactPaginate
                            previousLabel={
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M12.6665 8L3.33317 8" stroke="#042B33" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8 3.33329L3.33333 7.99996L8 12.6666" stroke="#042B33" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
                            }
                            nextLabel={
                           <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M3.3335 8L12.6668 8" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8 3.33329L12.6667 7.99996L8 12.6666" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
                            }
                            pageClassName="page-item"
                            pageLinkClassName="page-link"
                            previousClassName="page-item"
                            previousLinkClassName="page-link"
                            nextClassName="page-item"
                            nextLinkClassName="page-link"
                            breakLabel="..."
                            breakClassName="page-item"
                            breakLinkClassName="page-link"
                            pageCount={pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={handlePageChange}
                            containerClassName="pagination"
                            activeClassName="active"
                            forcePage={page}
                          ></ReactPaginate>
                        </ul>
                      ) : null}
                    </nav>
                  </ul>
                </nav>
              </div>
            )}
          </div>
        </div>
      </section>

      <Modal
        className="delete-modal global-modal-scss"
        show={show}
        onHide={handleClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Allow Claim</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="delete-modal-div">
            <h6>
              Are you sure you want to allow claim for the selected leader(s)
            </h6>
          </div>
          <div className="twice-btn">
            <button onClick={() => handleClose()} className="btn-cancel">
              Cancel
            </button>
            {/* handleClose(false);
            setShow2(true); */}
            <button
              className="btn-confirm"
              onClick={() => {
                allowClaim();
              }}
            >
              Confirm
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="add-mega-modal global-modal-scss"
        show={show2}
        onHide={handleClose2}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Allow Claim</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="add-mega-div scuhvscycvst">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="80"
              height="81"
              viewBox="0 0 80 81"
              fill="none"
            >
              <path
                d="M39.9997 78.3947C60.9284 78.3947 77.8945 61.4286 77.8945 40.5C77.8945 19.5713 60.9284 2.60522 39.9997 2.60522C19.071 2.60522 2.10498 19.5713 2.10498 40.5C2.10498 61.4286 19.071 78.3947 39.9997 78.3947Z"
                fill="#329879"
              />
              <path
                d="M36.1264 54.8997C35.5791 54.8997 35.0317 54.6892 34.6528 54.2681L22.9475 42.5629C22.1054 41.7208 22.1054 40.4155 22.9475 39.5734C23.7896 38.7313 25.0949 38.7313 25.937 39.5734L36.0001 49.6366L54.0212 26.8997C54.737 25.9734 56.0843 25.8471 56.9685 26.5629C57.8949 27.2787 58.0212 28.626 57.3054 29.5102L37.8107 54.0997C37.4317 54.5629 36.8843 54.8576 36.2949 54.8997C36.2107 54.8997 36.1686 54.8997 36.1264 54.8997Z"
                fill="#E2E9EC"
              />
            </svg>
            <h6>Claims Opened</h6>
          </div>
          <div className="twice-btn">
            <button
              className="btn-add"
              style={{ flex: "auto" }}
              onClick={handleClose2}
            >
              Okay
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="add-mega-modal global-modal-scss claiming-modal"
        show={show3}
        onHide={handleClose3}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Claiming</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="newclaiming-modal">
            <div className="left-side">
              <h6>Claiming Function (Admin)</h6>
              <p>
                This functions turns on or off the ability for the leaders to
                claim
              </p>
            </div>
            <div className="right-side">
              <div className="parent-toggle-switch-custom">
                <div class="custom-toggle">
                  <input
                    onChange={openClaim}
                    type="checkbox"
                    checked={claimStatus}
                    class="checkbox"
                    id="checkbox"
                  />
                  <label class="switch" for="checkbox">
                    <span class="slider"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Claim;
